import styled from 'styled-components'
import { theme } from '@/client/components'
const { borders, color, space, breakpoint } = theme

export const Featured = styled.div`
  padding-bottom: ${space.xl3};

  @media (min-width: ${breakpoint.lg}) {
    padding: ${space.lg} 0 ${space.xl3};
  }
`

export const MainFeatured = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: space-between;
  gap: ${space.xl};
  padding-top: ${space.xl};

  @media (min-width: ${breakpoint.lg}) {
    flex-direction: row;
    gap: ${space.xl6};
  }

  @media (min-width: ${breakpoint.xl}) {
    margin: 0 ${space.xl2};
  }
`

export const LeftFeatured = styled.div`
  order: 2;
  width: 100%;

  a {
    color: black;
    text-decoration: none;
  }

  @media (min-width: ${breakpoint.lg}) {
    order: 1;
    width: 43%;
  }
`

export const Video = styled.div`
  order: 1;
  position: relative;
  width: 100%;
  border: ${borders.sizes.xl} solid ${color.grayscale.white};
  border-radius: ${borders.radius.xl};
  box-shadow: 0px 0px 50px #1021331a;
  overflow: hidden;
  margin: 0 -${space.md};

  @media (min-width: ${breakpoint.lg}) {
    order: 2;
    width: 57%;
    margin: 0;
    background-color: transparent;
  }

  video {
    width: 100%;
    height: auto;
  }
`
